import { create } from "zustand";
import moment from "moment";



const mfpAdmin = [
    { value: "dsfadsf", label: "Jay Bruce" },
    { value: "jgfdtdh", label: "Adam Dunn" },
    { value: "kutv", label: "Ryan Freel" },
    { value: "sergh", label: "Jason LaRue" },
    { value: "vbghjj", label: "Aaron Harang" },
    { value: "sdfghj", label: "Bronson Arroyo" },
    { value: "iouytr", label: "Ken Griffey Jr." },
]


const statuses = [

    { value: 1, label: "Status A", reasonRequired: true, isInfoOnly: false, housingSupplementRequired: false },
    { value: 2, label: "Status B", reasonRequired: false, isInfoOnly: false, housingSupplementRequired: false },
    { value: 3, label: "Status C", reasonRequired: true, isInfoOnly: true, housingSupplementRequired: false },
    { value: 4, label: "Status D", reasonRequired: false, isInfoOnly: false, housingSupplementRequired: false },
    { value: 5, label: "Status E", reasonRequired: true, isInfoOnly: false, housingSupplementRequired: false },
    { value: 6, label: "Status F", reasonRequired: false, isInfoOnly: true, housingSupplementRequired: false },
    { value: 7, label: "Status G", reasonRequired: true, isInfoOnly: false, housingSupplementRequired: false },
    { value: 8, label: "Status H", reasonRequired: false, isInfoOnly: false, housingSupplementRequired: false },
    { value: 9, label: "Status I", reasonRequired: true, isInfoOnly: false, housingSupplementRequired: false },
    { value: 10, label: "Status J", reasonRequired: false, isInfoOnly: false, housingSupplementRequired: false },
    { value: 11, label: "Status K", reasonRequired: true, isInfoOnly: false, housingSupplementRequired: false },
    { value: 12, label: "Status L", reasonRequired: false, isInfoOnly: false, housingSupplementRequired: false },
    { value: 13, label: "Status M", reasonRequired: true, isInfoOnly: true, housingSupplementRequired: false },
    { value: 14, label: "Status N", reasonRequired: false, isInfoOnly: false, housingSupplementRequired: false },
    { value: 15, label: "Status O", reasonRequired: true, isInfoOnly: false, housingSupplementRequired: false },
    { value: 16, label: "Status P", reasonRequired: false, isInfoOnly: true, housingSupplementRequired: false },
    { value: 17, label: "Status Q", reasonRequired: true, isInfoOnly: false, housingSupplementRequired: false },
    { value: 18, label: "Status R", reasonRequired: false, isInfoOnly: true, housingSupplementRequired: false },
    { value: 19, label: "Status S", reasonRequired: true, isInfoOnly: false, housingSupplementRequired: false },
    { value: 20, label: "Status T", reasonRequired: false, isInfoOnly: false, housingSupplementRequired: false },
    { value: 21, label: 'Referral_Housing Housing Located Refer to UKHDI', reasonRequired: false, isInfoOnly: false, housingSupplementRequired: true }
];

const notifications = [
    {
        appId: "1234",
        date: "2025-01-05",
        message: "was signed by mpiton",

    },
    {
        appId: "3412",
        date: "2025-02-05",
        message: "needs your attention",

    },
    {
        appId: "1234",
        date: "2025-02-15",
        message: "was closed",

    },
    {
        appId: "1234",
        date: "2025-02-25",
        message: "was created by mpiton",
    }
]


const applicationStatusHistory = [
    {
        applicationStatusHistoryId: 1,
        statusId: 10,
        reason: "Not enough Data",
        isVoid: true,
        begin: "2025-02-05",
        end: "2025-01-02",
        submittedById: "ncage",
        lastModifiedById: "mpiton",
        submittedBy: "mpiton",
        lastModifiedBy: "mpiton",
        status: "Active",
        lastModifiedDate: "2025-02-26"
    },
    {
        applicationStatusHistoryId: 2,
        statusId: 11,
        reason: "Service not needed",
        isVoid: true,
        begin: "2025-01-01",
        end: "2025-01-02",
        submittedById: "mpiton",
        lastModifiedById: "jparker",
        submittedBy: "jrussell",
        lastModifiedBy: "tcruz",
        status: "Closed",
        lastModifiedDate: "2025-02-25"
    },
    {
        applicationStatusHistoryId: 3,
        statusId: 11,
        reason: "This a reason.",
        isVoid: false,
        begin: "2025-01-02",
        end: "2025-01-03",
        submittedById: "sergh",
        lastModifiedById: "kutv",
        submittedBy: null,
        lastModifiedBy: null,
        status: null,
        lastModifiedDate: "2025-01-02"
    },
    {
        applicationStatusHistoryId: 4,
        statusId: 12,
        reason: "",
        isVoid: false,
        begin: "2025-01-03",
        end: "2025-01-04",
        submittedById: "dsfadsf",
        lastModifiedById: "dsfadsf",
        submittedBy: null,
        lastModifiedBy: null,
        status: null,
        lastModifiedDate: "2025-01-03"
    },
    {
        applicationStatusHistoryId: 5,
        statusId: 13,
        reason: "This a reason.",
        isVoid: false,
        begin: "2025-01-04",
        end: "2025-01-05",
        submittedById: "dsfadsf",
        lastModifiedById: "dsfadsf",
        submittedBy: null,
        lastModifiedBy: null,
        status: null,
        lastModifiedDate: "2025-01-04"
    },
    {
        applicationStatusHistoryId: 6,
        statusId: 14,
        reason: "",
        isVoid: false,
        begin: "2025-01-05",
        end: "2025-01-06",
        submittedById: "sergh",
        lastModifiedById: "iouytr",
        submittedBy: null,
        lastModifiedBy: null,
        status: null,
        lastModifiedDate: "2025-01-05"
    },
    {
        applicationStatusHistoryId: 7,
        statusId: 15,
        reason: "This a reason.",
        isVoid: false,
        begin: "2025-01-06",
        end: "2025-01-07",
        submittedById: "sergh",
        lastModifiedById: "kutv",
        submittedBy: null,
        lastModifiedBy: null,
        status: "Open",
        lastModifiedDate: "2025-01-06"
    },
    {
        applicationStatusHistoryId: 8,
        statusId: 15,
        reason: "This a reason.",
        isVoid: false,
        begin: "2025-01-06",
        end: "2025-01-07",
        submittedById: "sergh",
        lastModifiedById: "kutv",
        submittedBy: "mpiton",
        lastModifiedBy: "mjones",
        status: "Processing",
        lastModifiedDate: "2025-01-06"
    },
    {
        applicationStatusHistoryId: 9,
        statusId: 16,
        reason: "",
        isVoid: false,
        begin: "2025-01-07",
        end: "2025-01-08",
        submittedById: "dsfadsf",
        lastModifiedById: "dsfadsf",
        submittedBy: null,
        lastModifiedBy: null,
        status: null,
        lastModifiedDate: "2025-01-07"
    },
    {
        applicationStatusHistoryId: 10,
        statusId: 17,
        reason: "This a reason.",
        isVoid: true,
        begin: "2025-01-08",
        end: "2025-01-09",
        submittedById: "sdfghj",
        lastModifiedById: "iouytr",
        submittedBy: null,
        lastModifiedBy: null,
        status: null,
        lastModifiedDate: "2025-01-08"
    },
    {
        applicationStatusHistoryId: 11,
        statusId: 18,
        reason: "",
        isVoid: false,
        begin: "2025-01-09",
        end: "2025-01-10",
        submittedById: "dsfadsf",
        lastModifiedById: "iouytr",
        submittedBy: null,
        lastModifiedBy: null,
        status: null,
        lastModifiedDate: "2025-01-09"
    },
    {
        applicationStatusHistoryId: 12,
        statusId: 19,
        reason: "This a reason.",
        isVoid: false,
        begin: "2025-01-10",
        end: null,
        submittedById: "sdfghj",
        lastModifiedById: "iouytr",
        submittedBy: null,
        lastModifiedBy: null,
        status: null,
        lastModifiedDate: "2025-01-15"
    }
];


const newId = (collection) => {

    const ids = collection.map(x => x.applicationStatusHistoryId);

    let newId = -1;
    while (newId == -1 || ids.includes(newId)) {
        newId = Math.round(Math.random() * 1000);
    }

    return newId;
};


const initialState = {
    statuses: statuses,
    applicationStatusHistory: applicationStatusHistory,
    notifications: notifications
};

const useTestApplicationStatusStore = create((set, get) => ({

    ...initialState,

    actions: {
        add: (newStatus) => {

            const current = get().applicationStatusHistory;
            const mostRecentIndex = current.findIndex(x => x.end == null);
            const mostRecent = { ...current[mostRecentIndex], end: moment().format() };
            current.splice(mostRecentIndex, 1, mostRecent);



            const newObj = {
                ...newStatus,
                applicationStatusHistoryId: newId(get().applicationStatusHistory),
                begin: moment().format(),
                lastModifiedDate: moment().format(),
                lastModifiedById: "dsfadsf",
                submittedById: "dsfadsf",
                end: null
            };

            current.push(newObj);

            return set({ applicationStatusHistory: [...current] });
        },
        toggleVoid: (id) => {
            //console.log(id);
            const current = get().applicationStatusHistory;
            const index = current.findIndex(x => x.applicationStatusHistoryId == id);
            const value = current[index];
            value.isVoid = !value.isVoid;
            current.splice(index, 1, value);
            set({ applicationStatusHistory: [...current] });
        },

        fetchStatuses: () => get().statuses,

        fetchHistory: (applicationId) => {

            const current = get().applicationStatusHistory;

            for (let i = 0; i < current.length; i++) {
                const element = current[i];

                element.lastModifiedBy = mfpAdmin.find(x => x.value == element.lastModifiedById);
                element.submittedBy = mfpAdmin.find(x => x.value == element.submittedById);
                element.status = statuses.find(x => x.value == element.statusId);

            }



            return current.sort((a, b) => a.end == null ? -1 : b.end == null ? -1 : moment(b.begin, ['YYYY-MM-DD']).diff(moment(a.begin, ['YYYY-MM-DD'])));
        },

        fetchApplicationHistory: (id) => {

            const current = get().applicationStatusHistory;
            let data = [];

            for (let i = 0; i < current.length; i++) {
                if (current[i].applicationStatusHistoryId.toString() == id.toString()) {
                    data.push(current[i]);
                }
            }
            // console.log(data)
            return data.sort((a, b) => a.end == null ? -1 : b.end == null ? -1 : moment(b.begin, ['YYYY-MM-DD']).diff(moment(a.begin, ['YYYY-MM-DD'])));

        },
        fetchApplicationHistoryRecent: () => {

            const now = moment();

            const current = get().applicationStatusHistory;
            let data = [];

            for (let i = 0; i < current.length; i++) {
                if (now.diff(current[i].lastModifiedDate, 'hours')< 48) {
                    data.push(current[i]);
                }
            }
            // console.log(data)
            return data.sort((a, b) => a.end == null ? -1 : b.end == null ? -1 : moment(b.begin, ['YYYY-MM-DD']).diff(moment(a.begin, ['YYYY-MM-DD'])));

        },
        fetchClientNotificationHistory: () => {
            const current = get().notifications;
            let data = [];

            for (let i = 0; i < current.length; i++) {
                data.push(current[i]);
            }

            return data.sort((a, b) => a.end == null ? -1 : b.end == null ? -1 : moment(b.begin, ['YYYY-MM-DD']).diff(moment(a.begin, ['YYYY-MM-DD'])));
        }
    }


}));


export default useTestApplicationStatusStore;